import { Element } from "./Element";
import { Label } from "./Label";
import { Root } from "./Root";

export const Select = {
    Root: Root,
    Element: Element,
    Label: Label
}